@if (!!adSubcategoryId && adSubcategoryId > 0) {
  <div class="mt-3 mt-lg-0 mb-0 mb-lg-4">
    <nz-search-filter
      (onClearFilters)="onClearFilters()"
      [activeFiltersCount]="activeFiltersCount">
      <div class="row g-4">
        <div class="col-12 col-sm-6">
          <span>Вид обяви</span>
          <ng-select
            [items]="adTypeOptions"
            bindValue="id"
            bindLabel="name"
            [clearable]="false"
            [searchable]="false"
            [(ngModel)]="adType"
            (ngModelChange)="onChangeAdType($event)"/>
        </div>
        @for (specification of adSubcategoryAssociatedSpecifications; track specification.adSpecificationId) {
          <div class="col-12 col-sm-6">
            <span>{{ specification.adSpecificationName }}</span>
            @if (specification.isSelectMultiple) {
              <ng-select
                bindValue="adSpecificationOptionId"
                bindLabel="adSpecificationOptionName"
                notFoundText="Няма намерени резултати"
                [ngModel]="adSpecificationIdsMultiple[specification.adSpecificationId]"
                [items]="adSpecificationOptions[specification.adSpecificationId]"
                [multiple]="specification.isSelectMultiple"
                [clearable]="specification.isSelectClearable"
                [searchable]="specification.isSelectSearchable"
                [placeholder]="getPlaceholder(specification.adSpecificationName)"
                (change)="onChangeAdSpecificationIdsMultiple(specification.adSpecificationId, $event)"/>
            } @else {
              <ng-select
                bindValue="adSpecificationOptionId"
                bindLabel="adSpecificationOptionName"
                notFoundText="Няма намерени резултати"
                [ngModel]="adSpecificationIdsSingle[specification.adSpecificationId]"
                [items]="adSpecificationOptions[specification.adSpecificationId]"
                [multiple]="specification.isSelectMultiple"
                [clearable]="specification.isSelectClearable"
                [searchable]="specification.isSelectSearchable"
                [placeholder]="getPlaceholder(specification.adSpecificationName)"
                (change)="onChangeAdSpecificationIdsSingle(specification.adSpecificationId, $event)"/>
            }
          </div>
        }
      </div>
    </nz-search-filter>
  </div>
}
